module.exports = __webpack_public_path__ + "media/assets/images/category/StPatrickssDay@2x-35324c51d11686853b86464e5652fbde.png";